{
  "validations": {
    "required": "This field is required",
    "email": "Invalid email address",
    "workflow": {
      "rejectCommentRequired": "Comment is required when rejecting"
    },
    "contributorOwnerMustBeInCategory": "Owner with contributor role must be in the same category as the document",
    "contributorPublisherMustBeInCategory": "Publisher with contributor role must be in the same category as the document",
    "endDateAfter": "End date must be after start date",
    "allStepsMustHaveAName": "All steps must have a name",
    "workflowDatesMustFollowPrevious": "Each workflow date must be the same as or after the previous one"
  }
}
